import gql from 'graphql-tag';

export const SAVE_UI_SETTINGS = gql`
    mutation saveSettings($settings: DynamicObject!) {
        saveUISettings(settings: $settings, merge: true)
    }
`